import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Shortlist from './shortlist';
import ListShortlists from './ListShortLists';
import ShortListFromISRC from './ShortListFromISRC';
import "react-table/react-table.css";
import Select from 'react-select';
import ReadyShortlist from './ReadyShortlists';
import { CSVLink } from 'react-csv';


class UpdateProductMass extends Component {

    constructor(props) {
        super(props);
        this.state = {
            codes: "",
            isrcs: "",
            prop_value: "",
            selectedOption: null,
        };
     
    }
componentDidMount() {
    // This method is called when the component is first added to the document
   
    this.ensureDataFetched();
   
   
}

componentDidUpdate() {
    // This method is called when the route parameters change
    //this.ensureDataFetched();
    if (this.props.massProductChangeCodes.length > 0 && !this.props.isSavingMassProductChange) {
        this.props.saveMassProductChanges(this.props.massProductChangeCodes[0], this.props.requestedMassProductChangeProperty, this.props.requestedMassProductChangeValue);
    }
   
   
    }

   

ensureDataFetched() {
   
    // this.props.requestWeatherForecasts(startDateIndex);
   // this.props.getData();
 
    }


    onUPCChange(e) {
        this.setState({ codes: e.target.value });
    }

    onValuesChange(e) {
        this.setState({ prop_value: e.target.value });
    }

    onISRCChange(e) {
        this.setState({ isrcs: e.target.value });
    } 

    selectListType(data) {

        this.setState(
            { selectedOption : data });

    }

    setProductUpdate(e, selection, _value) {
        var array = e.split(" ");       
        this.props.setMassProductChangeCodes(array,selection,_value);
    }


render() {
    const access = localStorage.getItem("accessToken");    
    let url = this.props ? this.props.audioURL : '';
    const options = [
        { value: 'c_line_text', label: 'c_line_text' },
        { value: 'p_line_text', label: 'p_line_text' },
        { value: 'c_line_year', label: 'c_line_year' },
        { value: 'p_line_year', label: 'p_line_year' },        
    ];
    const { selectedOption } = this.state;

    
    

    return (
        <div>              
                <h1>C&P Update</h1>

            <p>{this.props.massProductChangeCodes.length} items left to update </p>
            <p>{this.props.massProductChangeCodes.length > 0 ? "Updating " + this.props.requestedMassProductCode + " " + this.props.requestedMassProductChangeProperty +  " to " + this.props.requestedMassProductChangeValue : ""}</p>
            <p>{this.props.massProductChangeCodes.length > 0 ? "(please don't reload or close the tab)" : ""}</p>
          
                <div className="row">
                <div className="col-sm-12">
                    <input type="text" disabled={this.props.isSavingMassProductChange || this.props.massProductChangeCodes.length > 0} className="form-control" id="shortlistISRC" placeholder={"UPCS to Update"} onChange={(e) => this.onUPCChange(e)} value={this.state.codes} ></input>
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col-sm-6">
                    <input type="text" disabled={this.props.isSavingMassProductChange || this.props.massProductChangeCodes.length > 0} className="form-control" id="prop_values" placeholder={"Value to update"} onChange={(e) => this.onValuesChange(e)} value={this.state.prop_value} ></input>
                </div>
                <div className="col-sm-3">
                    <Select
                        isLoading={options.length === 0}
                        name="form-field-name"
                        value={selectedOption}
                        options={options}
                        multi={false}
                        onChange={(data) => this.selectListType(data)}
                        disabled={this.props.isSavingMassProductChange || this.props.massProductChangeCodes.length > 0 }
                    /></div>
                <div className="col-sm-3">
                    <button disabled={this.state.codes === '' || this.props.isSavingMassProductChange || selectedOption === null || this.state.prop_value === "" || this.props.massProductChangeCodes.length > 0} onClick={(e) => this.setProductUpdate(this.state.codes, selectedOption.value, this.state.prop_value)}>Update</button></div>
            </div>
            <div>
            <br />

          
            <br/>
                <div className="row">
                <div className="col-sm-12">
                    {this.props.massProductChangeResults !== null && this.props.massProductChangeResults.length > 0 ? <CSVLink separator=";" data={this.props.massProductChangeResults} filename={ "mass-products-update-List-Data.csv"} >Download CSV</CSVLink> : ""}
                    {this.props.massProductChangeResults.length > 0 ? renderReactTable(this.props.massProductChangeResults, this.props, this) : ""}
                    </div>
                </div>

            </div></div>
          
     
            
            
          

        
    );
}
}



function renderReactTable(data, props,main) {

    console.info(main.state.filtered);

    const getColumns = () => {
        return Object.keys(data[0]).map(key => {
            return {
                Header: key,
                accessor: key
            };
        });
    }
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {
              
                style: {
                    background: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? '#00afec' : 'white',
                    color: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? 'white' : 'black',
                    
                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}
          
            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;                
                if (typeof filter.value === "object") {                    
                    return row[id] !== undefined || row[id] !==  null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}

              
            columns={getColumns()}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={50}
            style={{
                height: "600px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};





export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(UpdateProductMass);



// WEBPACK FOOTER //
// ./src/components/UpdateProductMass.js